import WelcomeContainer from './welcome_container';

const Welcome = WelcomeContainer;
export default Welcome;
